import {Injectable, Renderer2, RendererFactory2, EventEmitter} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LANG_KEY_LOCAL_STORAGE_KEY, languages} from '../../app.constants';
import {StorageService} from './storage.service';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import * as moment from 'moment';
import {CookieTypesEnum} from '../../shared/enums/cookie-types.enum';
import {AppService} from '../../shared/services/app.service';

@Injectable({providedIn: 'root'})
export class LanguageService {

    private readonly renderer: Renderer2 | any = null;
    languageChangeEmitter: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private translateService: TranslateService,
        public rootRenderer: RendererFactory2,
        private storageService: StorageService,
        private appService: AppService
    ) {
        this.renderer = rootRenderer.createRenderer(document.querySelector('html'), null);
        this.init();
    }

    getAll(): string[] {
        return languages.map(item => item.key);
    }

    getLocalCurrentLanguage() {
        return this.translateService.currentLang;
    }

    changeLanguage(langKey: string) {
        this.translateService.use(langKey);
        if (this.appService.isCookieIsAllowed(CookieTypesEnum.PREFERENCES)) {
            this.storageService.save(LANG_KEY_LOCAL_STORAGE_KEY, langKey);
        }

        switch (langKey) {
            case 'de':
                registerLocaleData(localeDe, 'de');
                moment.locale('de');
                break;
            case 'en':
                registerLocaleData(localeEn);
                moment.locale('en');
                break;
            default:
                break;
        }
    }

    private init() {
        this.translateService.onLangChange.subscribe(() => {
            this.renderer.setAttribute(document.querySelector('html'), 'lang', this.translateService.currentLang);
        });
    }

}
